import { useAuthContext } from "@kalyzee/kast-web-sdk";
import { AppVersion, Button } from "@kalyzee/kast-web-sdk/web-components";
import { MasterUI } from "../../../components/common/MasterUI";
import { AnimatedBackground } from "../../../components/utils/AnimatedBackground";
import { useLogger } from "../../../helpers/logger";
import styles from "./logout.module.css";

const LogoutPage = () => {
  const logger = useLogger();

  const { logout } = useAuthContext();

  const onLogout = () => {
    logger.log("[LOGOUT] : on logout button press");
    logout();
  };

  return (
    <MasterUI>
      <AnimatedBackground contentClassName={styles.container}>
        <div style={{ minWidth: "200px" }}>
          <Button
            title="Se déconnecter"
            onClick={onLogout}
          />
        </div>
        <AppVersion />
      </AnimatedBackground>
    </MasterUI>
  );
};

export default LogoutPage;
